import { render, staticRenderFns } from "./detailsWindow.vue?vue&type=template&id=6a4ddfeb&scoped=true"
import script from "./detailsWindow.vue?vue&type=script&lang=js"
export * from "./detailsWindow.vue?vue&type=script&lang=js"
import style0 from "./detailsWindow.vue?vue&type=style&index=0&id=6a4ddfeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ddfeb",
  null
  
)

export default component.exports